const setBuildingAndUnit_sec3 = (payload) => {
  return {
    type: "BuildingAndUnit_sec3",
    payload,
  };
};

export default setBuildingAndUnit_sec3;
